import { useEffect } from 'react';
import { useMatch, Outlet, useNavigate } from 'react-router-dom';
import { PermissionDenied, PermissionEnum } from '@ui/src';
import { useAppSelector, useAppDispatch } from '@store';
import { clearProcessingRulesState } from './store/slice';

import ROUTES from '../../../routes';

import cn from '../../settings/styles.module.css';

const ProcessingRules = () => {
  const match = useMatch(ROUTES.TRANSACTION_SETTINGS_PROCESSING_RULES);

  const { activePermissions } = useAppSelector(
    (state) => state.administrationDictionaries,
  );

  const navigate = useNavigate();
  const dispatch = useAppDispatch();

  useEffect(() => {
    if (
      activePermissions?.includes(PermissionEnum.TRANSACTIONS_RULES_LIST) &&
      match
    ) {
      navigate(ROUTES.TRANSACTION_SETTINGS_PROCESSING_RULES_LIST);
    }

    return () => {
      dispatch(clearProcessingRulesState());
    };
  }, [activePermissions, match]);

  useEffect(() => {
    let title = 'Transaction Settings: Processing Rules';

    const companyName = localStorage.getItem('companyName');

    if (companyName) {
      title = `${title} | ${companyName}`;
    }

    document.title = title;
  }, []);

  const content = !activePermissions?.includes(
    PermissionEnum.TRANSACTIONS_RULES_LIST,
  ) ? (
    <PermissionDenied />
  ) : (
    <Outlet />
  );

  return <div className={cn.beneficiariesSettingsContent}>{content}</div>;
};

export default ProcessingRules;
